import React from 'react'
import MainLayout from '../../layouts/Main'
import { PageTitle } from '../../components'
import './styles.css'



const CopyrightView = () => {
    return (
        <MainLayout>
            <div className="row justify-content-center">
                <main className="col-md-12 col-lg-10">
                    <PageTitle>Авторско право</PageTitle>
                    <p>
                        Дизайнът, структурата и съдържанието на този уебсайт са предмет на авторско право. 
                        Автор на културноестетическата платформа и литературноисторическата концепция е доц. д-р Мила Кръстева. Автор на интернет реализацията на сайта е Иван Иванов. Коректори на сайта са гл. ас. д-р Вяра Найденова и гл. ас. д-р Здравко Дечев. 
                    </p>
                    <p>
                        Уебсайтът е изработен от творческата лаборатория „CART Lab“ при Пловдивския университет „Паисий Хилендарски“ с научен ръководител гл. ас. д-р Атанас Терзийски. 
                        Сайтът е собственост на Проекта „От уста на ухо“... до Internet“ – Проект № ФП-17 ФЛФ-004 / 16.05.2017 с ръководител доц. д-р Мила Кръстева. Наши академични партньори са учени от Българската академия на науките (София), Пловдивския университет „Паисий Хилендарски“ – Филиал в гр. Смолян, Югозападния университет „Неофит Рилски“. Чуждестранен академичен партньор е Институтът по хуманитарно образование при Магнитогорския държавен технически университет „Г. И. Носов“, представен от почетния професор на Магнитогорския държавен технически университет проф. д.ф.н. Светлана Григориевна Шулежкова, която е и ръководител на Научноизследователската  лексикографска лаборатория към Научноизследователския институт по историческа антропология и филология в университета. Член на екипа е и италианецът гл. ас. д-р Роберто Адинолфи.
                    </p>
                    <p>
                        Потребителите могат да отпечатват отделни страници, изображения, емблеми, графики и др. от уебсайта на проекта, но без правото да отстраняват съпътстващите ги авторски знаци, запазени марки и др., изработени за Проекта. При отпечатване или друго ползване на съдържание от уебсайта потребителите са длъжни да цитират източника на информацията, а именно: http://nauho.paissiada.com
                    </p>
                    <p style={{textAlign: 'right', textAlignLast: 'right'}}>
                        ©   Доц. д-р Мила Кръстева <br/>
                        ©   Иван Иванов 
                    </p>
                    <p><strong>Пловдив, май 2017 – ноември 2018 г.</strong></p>
                </main>
            </div>
        </MainLayout>
    )
}


export default CopyrightView



// WEBPACK FOOTER //
// ./src/views/Copyright/index.js